import type { UnknownAction, ThunkDispatch } from '@reduxjs/toolkit'
import { clearSession } from './slices/session.slice'
import { logoutAuthProfile } from './slices/auth.slice'

/** Clears profile (localStorage) and session (sessionStorage). */
export function logoutAuthUser() {
  return (dispatch: ThunkDispatch<unknown, unknown, UnknownAction>) => {
    dispatch(logoutAuthProfile())
    dispatch(clearSession())
  }
}
